// extracted by mini-css-extract-plugin
module.exports = {"main":"State_main__aJBNo","icon":"State_icon__vNRht","title":"State_title__azYHv","description":"State_description__hu2ph"};